import request from '@/utils/zsm-requets'
const event = '/zsm/api/sale/event/'
const pick = '/zsm/api/sale/pick/'
/**
 * 创建优惠券
* @param eventDict;      // 促销类型 101=固定时间促销活动，201=优惠券 301 = 买赠套餐 2012 = 分享券 2013 = 直播券
* @param goodId;    // 商品
* @param goodName;      // 商品
* @param authorId;      // 作者
* @param authorName;    // 作者
* @param shopId;    // 门店
* @param shopName;      // 门店
* @param  originPrice;       // 原价
* @param  eventPrice;    // 促销活动价
* @param  subtractPrice;  //优惠价=原价-促销活动价
* @param startTime;       // 开始日期
* @param endTime;     // 截止日期
* @param openFlag;      // 手动开启或关闭促销活动  0=关闭  1=开启
* @param stockFlag;     // 是否有库存限制。0=无限制，1=有限制
* @param stockCountFlag;
* @param cover;            //活动或优惠券的封面
* @param  stockCount;       // 总库存数量.只有stockFlag=1时有效
* @param  remainCount;    //剩余库存数量.只有stockFlag=1时有效
* @param title;     // 活动标题或优惠券名称
* @param timeDict;      // 优惠券有效期类型   0=与活动时间一致，1=自定义时间（此时下面三个字段才有意义）
* @param  timeDay;      // timeDict=1时，这里代表天数量
* @param  timeHour;     // timeDict=1时，这里代表小时数量
* @param  timeMin;      // timeDict=1时，这里代表分钟数量
 */
export function createEvent(params) {
  return request({
    url: event + 'create',
    method: 'post',
    params
  })
}

/*
  查看某一个优惠券
  id 优惠券id
*/

export function getEvent(id) {
  return request({
    url: event + 'get',
    method: 'post',
    params: { id }
  })
}

/*
  查看优惠券列表
  参数与创建时一致
*/

export function listDataEvent(params) {
  return request({
    url: event + 'listData',
    method: 'post',
    params
  })
}

/*
  修改优惠券
  参数与创建时一致
*/

export function updateEvent(params) {
  return request({
    url: event + 'update',
    method: 'post',
    params
  })
}

/*
  删除优惠券
  参数与创建时一致
*/

export function deleteEvent(id) {
  return request({
    url: event + 'delete',
    method: 'post',
    params: { id }
  })
}

/*
* 开启-关闭
* */
export function toggleEvent(params) {
  return request({
    url: event + 'toggle',
    method: 'post',
    params
  })
}

/*
* 领取优惠券
* */
export function createPick(params) {
  return request({
    url: pick + 'create',
    method: 'post',
    params
  })
}

/*
* 领取的优惠券列表
* */
export function listDataPick(params) {
  return request({
    url: pick + 'listData',
    method: 'post',
    params
  })
}

